import React from 'react';

import BatteryIcon from '@/components/Icons/BatteryIcon';
import appContent from '@/services/content/appContent';
import {formatString} from '@/utils/stringUtils';
import {twx} from '@/utils/tailwindUtils';

const Battery = ({percentage, className}) => {
    const isBatteryChargeValid = percentage !== undefined && percentage <= 100 && percentage >= 0;

    if (!isBatteryChargeValid) return null;

    const {batteryTitle, batteryAriaLabel} = appContent.getDeviceStatusContent();
    const fillColor = percentage <= 25 ? '#FFE5B052' : 'var(--color-primary)';

    return (
        <div className={twx('flex items-center gap-[6px]', className)}>
            <span className='text-14 font-bold tracking-02 text-black' aria-hidden>
                {formatString(batteryTitle, percentage)}
            </span>
            <BatteryIcon
                fill={fillColor}
                stroke='var(--color-primary)'
                percentage={percentage}
                aria-label={formatString(batteryAriaLabel, percentage)}
            />
        </div>
    );
};

export default Battery;
